import { render, staticRenderFns } from "./ViewCaixaPacpon.vue?vue&type=template&id=f2bf5236&scoped=true&"
import script from "./ViewCaixaPacpon.vue?vue&type=script&lang=js&"
export * from "./ViewCaixaPacpon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf5236",
  null
  
)

export default component.exports